export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    //  { label: "展馆ID", prop: "exhibitionID", width: 80},
    { label: "出诊ID", prop: "id", width: 80 },
    { label: "出诊海报", prop: "activeImg", slots: "activeImg", width: 150 },
    { label: "出诊名称", prop: "activeName" },
    { label: "开始时间", prop: "startTime", width: 150 },
    { label: "结束时间", prop: "endTime", width: 150 },
    // { label: "入口地址", prop: "addressMsg"},
    // {
    //   label: "创建日期",
    //   prop: "createTime",
    //   width: 180,
    // },
    {
      label: "操作",
      prop: "operation",
      width: 120,
      slots: "operation",
      fixed: "right",
    },
  ];
}
